// MUST be first — polyfills `crypto.randomUUID` in non-secure contexts (e.g.
// http://local.devtempus.com) before any dependency's module code runs. See
// `src/polyfills.ts` for rationale.
import './polyfills';

import { AppWrapper } from '@tempus/t-shared/ui';
import type { AuthorizationWrapperProps } from '~/types/tShared';
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import '@tcl-boron-fonts/ibm-plex-sans/dist/ibm-plex-sans.css';

import App from './components/App';
import { config } from './config';
import store from './store';
import { restoreRouterHistoryIndex } from './utils/routerHistoryState';

const oktaOptions: AuthorizationWrapperProps['oktaOptions'] = {
  oktaClientID: config.okta.oktaClientId,
  loginServiceURI: config.okta.loginServiceUri,
  authenticationServiceURI: config.okta.oktaIssuerUrl,
};

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

/** Data router required for `useBlocker` (`useLeaveGuard`). */
const router = createBrowserRouter([
  {
    path: '*',
    element: <App />,
  },
]);
const routerHistorySnapshot: unknown = window.history.state;

/** Rendered inside `AppWrapper`, so it mounts after `authorize()` has rewritten history state. */
function RouterHistoryIndexRestore() {
  useEffect(() => {
    restoreRouterHistoryIndex(routerHistorySnapshot);
  }, []);
  return null;
}

root.render(
  // @ts-expect-error -- tempus/t-shared redux types are not compatible with our setup
  <AppWrapper store={store} oktaOptions={oktaOptions} pendoAccountId="therapies">
    <RouterHistoryIndexRestore />
    <RouterProvider router={router} />
  </AppWrapper>,
);
